import api from './api';
import { ApiResponse, ReferralStats, ReferralList, Top10ReferralResponse } from '../types';

/**
 * Referral API Service
 * Handles all referral-related API calls
 */
export const referralApi = {
  /**
   * Get user's referral statistics
   */
  getStats: async (): Promise<ApiResponse<ReferralStats>> => {
    try {
      const response = await api.get('/referrals/stats');
      return response.data;
    } catch (error: any) {
      console.error('Error fetching referral stats:', error);
      throw error;
    }
  },

  /**
   * Get list of users referred by this user
   */
  getList: async (page: number = 1, limit: number = 20): Promise<ApiResponse<ReferralList>> => {
    try {
      const response = await api.get('/referrals/list', {
        params: { page, limit }
      });
      return response.data;
    } catch (error: any) {
      console.error('Error fetching referral list:', error);
      throw error;
    }
  },

  /**
   * Get current month's Top 10 referrers
   */
  getCurrentTop10: async (): Promise<ApiResponse<Top10ReferralResponse>> => {
    try {
      const response = await api.get('/referrals/top10/current');
      return response.data;
    } catch (error: any) {
      console.error('Error fetching current Top 10:', error);
      throw error;
    }
  },

  /**
   * Get Top 10 referrers for a specific month
   */
  getTop10ByMonth: async (year: number, month: number): Promise<ApiResponse<Top10ReferralResponse>> => {
    try {
      const response = await api.get(`/referrals/top10/${year}/${month}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching Top 10 by month:', error);
      throw error;
    }
  },

  /**
   * Admin: Manually trigger monthly reward distribution
   */
  triggerMonthlyReward: async (): Promise<ApiResponse<any>> => {
    try {
      const response = await api.post('/referrals/trigger');
      return response.data;
    } catch (error: any) {
      console.error('Error triggering monthly reward:', error);
      throw error;
    }
  }
};

export default referralApi;
